type Question = {
    id: number;
    questionTypeId: number;
    questionLogicsEntity?: Array<{
        optionId: number;
        targetQuestionId: number;
        sourceQuestionId: number;
    }> | null;
};

type FormValues = Record<string, any>;

const hasLogicJump = (question: Question) => question.questionTypeId === 1 && Array.isArray(question.questionLogicsEntity) && question.questionLogicsEntity.length > 0;

const getSelectedOptionId = (question: Question, formValues: FormValues): number | undefined => {
    const value = formValues[`${question.id}-1`];
    if (!Array.isArray(value) || value[0] === '' || value[0] === null || value[0] === undefined) {
        return undefined;
    }
    return Number(value[0]);
};

const findLogicByOption = (question: Question, optionId: number) => question.questionLogicsEntity?.find(item => item.optionId === optionId);

export const getVisibleQuestionList = (list: Question[], formValues: FormValues = {}): Question[] => {
    if (!list?.length) {
        return [];
    }

    const visible: Question[] = [];
    let index = 0;

    while (index < list.length) {
        const question = list[index];
        visible.push(question);

        if (!hasLogicJump(question)) {
            index += 1;
            continue;
        }

        const selectedOptionId = getSelectedOptionId(question, formValues);
        if (!selectedOptionId) {
            break;
        }

        const logic = findLogicByOption(question, selectedOptionId);
        if (!logic) {
            index += 1;
            continue;
        }

        if (logic.targetQuestionId === -1) {
            break;
        }

        const targetIndex = list.findIndex(item => item.id === logic.targetQuestionId);
        if (targetIndex === -1) {
            index += 1;
            continue;
        }

        index = targetIndex;
    }

    return visible;
};

export const getVisibleQuestionIds = (list: Question[], formValues: FormValues = {}) => new Set(getVisibleQuestionList(list, formValues).map(item => item.id));

export const getVisibleFormFieldNames = (list: Question[]) => list.map(item => `${item.id}-${item.questionTypeId}`);
